const divElements = document.querySelectorAll('.get-css');
let styleText = '';
divElements.forEach(div => {
    styleText += div.innerText + '\n';
});

const styleElement = document.createElement('style');
styleElement.innerText = styleText.replace(/<br\s*\/?>/gi, '');
document.head.appendChild(styleElement);
